import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver'; // 需要之前安装的file-saver

// 格式化数据（根据你的表格结构调整）
const formatJson = (filterVal: string[], jsonData: any[]) => {
  return jsonData.map(item => {
    return filterVal.map(key => {
      return item[key];
    });
  });
};

// 导出Excel方法
export async function exportWithExcelJS(header: string[], data: any[], fileName: string) {
  // 创建工作簿
  const workbook = new ExcelJS.Workbook();
  // 添加工作表
  const worksheet = workbook.addWorksheet('数据报表');
  
  // 设置表头
  worksheet.addRow(header);
  // 表头样式（可选）
  header.forEach((_, index) => {
    const cell = worksheet.getCell(1, index + 1);
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }
    };
  });
  
  // 添加数据
  data.forEach(row => {
    worksheet.addRow(row);
  });
  
  // 调整列宽（自动适应内容）
  worksheet.columns.forEach(column => {
    column.width = 15; // 可根据需要调整
  });
  
  // 生成文件并下载
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(blob, `${fileName}.xlsx`);
}
